import {collection, CollectionReference, doc, getDoc, getFirestore, setDoc} from "firebase/firestore"
import {UserClimbingEvent, UserRouteStatus} from "../../models/UserClimbingEvent"
import {Sex} from "../../models/UserData"
import {ClimbingEventRoutesResults, UserRoutes} from "../../models/ClimbingEventRoutesResults";
import {EventRoutesResultConverter} from "./converters/EventRoutesResultConverter";


const converter = new EventRoutesResultConverter()

const getDocumentReference = (eventId: string): CollectionReference<ClimbingEventRoutesResults> => collection(getFirestore(), `climbingEvents/${eventId}/routesResults`).withConverter(converter)

export const calculateAndUpdateRouteResults = (climbingEvents: UserClimbingEvent[]): ClimbingEventRoutesResults[] => {
  if (climbingEvents.length <= 0) {
    return []
  }
  const eventId = climbingEvents[0].eventId
  let routesResults = Object.values(Sex).map(s => getRouteResultsForSex(climbingEvents, s))
  routesResults.forEach(r => {
    const documentRef = doc(getDocumentReference(eventId), r.sex.toString())
    setDoc(documentRef, r).then(r => console.log("updated routes"))
  })
  return routesResults
}

export const getRoutesResults = async (eventId: string): Promise<ClimbingEventRoutesResults[]> => {
  let results: ClimbingEventRoutesResults[] = []
  for await (const sex of Object.values(Sex)) {
    const documentRef = doc(getDocumentReference(eventId), sex.toString())
    let document = (await getDoc(documentRef)).data()
    if (document) {
      results.push(document)
    }
  }
  return results
}
export const getRoutesResultsFor = async (eventId: string, sex: Sex): Promise<ClimbingEventRoutesResults> => {
  const documentRef = doc(getDocumentReference(eventId), sex)
  const document = await getDoc(documentRef);
  if (document.exists()) {
    return document.data()
  } else {
    throw new Error(`nie ma aktualnie żadnych danych dla tego eventu `);
  }

}

function getRoutesByStatus(ce: UserClimbingEvent, zone: UserRouteStatus) {
  return ce.climbingRoutes.filter(r => r.status === zone)
    .map(r => r.id)
    .sort((n1: number, n2: number) => n1 - n2)
    .join(", ");
}

const getRouteResultsForSex = (climbingEvents: UserClimbingEvent[], sex: Sex): ClimbingEventRoutesResults => {

  const results = new ClimbingEventRoutesResults(sex)
  climbingEvents.filter(ce => ce.sex && ce.category)
    .filter(ce => ce.sex === sex)
    .map<UserRoutes>(ce => ({
      zones: getRoutesByStatus(ce, UserRouteStatus.ZONE),
      zones_2: getRoutesByStatus(ce, UserRouteStatus.ZONE2),
      top: getRoutesByStatus(ce, UserRouteStatus.DONE),
      flash: getRoutesByStatus(ce, UserRouteStatus.FLASH),
      userId: ce.userId
    })).forEach(u => results.userRoutes.set(u.userId, u))
  return results
}
